module.exports = __webpack_public_path__ + "img/antes_despues_135.48a9ba42.png";